/**
 * Line icons for the class detail screen.
 *
 * All of them share one stroke geometry (24-unit box, 1.6 stroke, round caps)
 * so the "What's included" grid reads as a single set rather than a collection.
 * Stroke colour is inherited, which is what lets the same icon sit on the page
 * background and inside the purple capacity chips.
 */

const base = {
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.6,
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
};

export const PaxIcon = () => (
  <svg {...base}>
    <circle cx="12" cy="7" r="3" />
    <path d="M6 20c.4-4.3 2.4-6.5 6-6.5s5.6 2.2 6 6.5" />
  </svg>
);

export const BagIcon = () => (
  <svg {...base}>
    <rect x="5" y="7" width="14" height="13" rx="2" />
    <path d="M9 7V5.5A2.5 2.5 0 0 1 11.5 3h1A2.5 2.5 0 0 1 15 5.5V7M9 11v5m6-5v5" />
  </svg>
);

export const ChauffeurIcon = () => (
  <svg {...base}>
    <circle cx="9" cy="5.5" r="2.5" />
    <path d="M4 21c0-4.4 2-6.8 5-6.8s5 2.4 5 6.8" />
    <path d="M16 10h5v6h-5z" />
    <path d="M18.5 16v5" />
  </svg>
);

export const ClockIcon = () => (
  <svg {...base}>
    <circle cx="12" cy="12" r="8.5" strokeDasharray="2.6 2.4" />
    <path d="M12 7.5V12l3 2" />
  </svg>
);

export const CarCancelIcon = () => (
  <svg {...base}>
    <path d="M3.5 15v-2.2l1.7-4A2 2 0 0 1 7 7.5h7.5" />
    <path d="M3.5 15h11" />
    <circle cx="7" cy="17" r="1.6" />
    <path d="m17.2 14.2 3.6 3.6m0-3.6-3.6 3.6" />
  </svg>
);

export const ChargerIcon = () => (
  <svg {...base}>
    <rect x="7" y="3.5" width="9" height="17" rx="2.2" />
    <path d="M11.5 8.5 10 12h3l-1.5 3.5" />
    <path d="M19 9.5v5" />
  </svg>
);

export const TissueIcon = () => (
  <svg {...base}>
    <path d="M3.5 15.5c2.3 2.2 5.2 3.3 8.5 3.3s6.2-1.1 8.5-3.3" />
    <path d="M7 12.5c1.4 1.3 3.1 2 5 2s3.6-.7 5-2" />
    <path d="M12 3.5c1.6 1.9 2.4 3.3 2.4 4.3a2.4 2.4 0 1 1-4.8 0c0-1 .8-2.4 2.4-4.3Z" />
  </svg>
);

export const WaterIcon = () => (
  <svg {...base}>
    <path d="M10 3h4v2.2c0 .7.3 1.3.8 1.8l.5.5c.5.5.7 1.1.7 1.8V19a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V9.3c0-.7.2-1.3.7-1.8l.5-.5c.5-.5.8-1.1.8-1.8V3Z" />
    <path d="M8 12h8" />
  </svg>
);

export const SparkleIcon = () => (
  <svg {...base}>
    <path d="M12 3.5 13.7 9l5.5 1.7-5.5 1.7L12 18l-1.7-5.6L4.8 10.7 10.3 9 12 3.5Z" />
  </svg>
);

export const ReceiptIcon = () => (
  <svg {...base}>
    <path d="M6 3.5h12v17l-2-1.4-2 1.4-2-1.4-2 1.4-2-1.4-2 1.4v-17Z" />
    <path d="M9 8.5h6M9 12h6M9 15.5h3.5" />
  </svg>
);

export const CarIcon = () => (
  <svg {...base}>
    <path d="M3.5 16v-3l1.9-4.4A2 2 0 0 1 7.2 7.3h9.6a2 2 0 0 1 1.8 1.3L20.5 13v3" />
    <path d="M3.5 16h17" />
    <circle cx="7.5" cy="17.6" r="1.7" />
    <circle cx="16.5" cy="17.6" r="1.7" />
  </svg>
);

export const SeatIcon = () => (
  <svg {...base}>
    <path d="M7 4.5h3.8a2 2 0 0 1 2 1.7l1 7.3H8.4a2 2 0 0 1-2-1.8L5.7 6.7A2 2 0 0 1 7 4.5Z" />
    <path d="M6.5 13.5h10a2 2 0 0 1 2 2v4" />
    <path d="M6.5 13.5v6" />
  </svg>
);

export const PawIcon = () => (
  <svg {...base}>
    <ellipse cx="7" cy="9.5" rx="1.9" ry="2.4" />
    <ellipse cx="12" cy="7.8" rx="1.9" ry="2.5" />
    <ellipse cx="17" cy="9.5" rx="1.9" ry="2.4" />
    <path d="M12 12.6c2.6 0 4.6 1.8 4.6 4a2.6 2.6 0 0 1-3.6 2.4 2.6 2.6 0 0 0-2 0 2.6 2.6 0 0 1-3.6-2.4c0-2.2 2-4 4.6-4Z" />
  </svg>
);
